<template>
  <div class="czzn-cpjs">
    <div class="cjwt-main-tit"><h2>其他问题：</h2></div>
    <div class="cjwt_main_con">
      <v-wd v-for="(item, index) in wdArr" :key="index" :wtda="item" ></v-wd>
    </div>
  </div>
</template>
<script>
import vWd from '../../components/wd.vue';

export default {
  name: 'cjwt_qtwt',
  components: {
    vWd,
  },
  data() {
    return {
      wdArr: [
        {
          question: '财务服务和技术服务是免费的吗？',
          answer: '部分技术服务和财税服务是免费的，对于个别增值服务需要您办理会员或额外付费。',
        },
        {
          question: '软件使用中遇到问题如何解决？',
          answer: '软件遇到使用问题或其他有需要帮助的，直接找在线客服或给您的专属客户经理打电话都可以，我们会第一时间为您答疑解惑。',
        },
        {
          question: '软件如果到期后还能进行操作吗？',
          answer: '软件到期后，还会为您提供数据查询服务，但不能进行新业务的录入，您需要进行续费后方可操作。',
        },
        {
          question: '不续费数据会保存多久？',
          answer: '我们在您到期后，会对您的数据进行3个月的保留，如果3个月后您不进行续费，系统提示并自动清空您的数据。',
        },
      ],
    };
  },
};
</script>
